import { Component, OnInit, ViewChild } from "@angular/core";

import { SharedDataService } from "../shared-data.service";
import { CustomDataService } from "../main/accountant/setup-and-settings/client-contact-fields/custom-data.service";
import { TagAddComponent } from "../main/common/tags/tag-add/tag-add.component";
import { LazyLoadEvent, SharedModule } from "primeng/api";
import { DataFieldFor } from "../main/accountant/setup-and-settings/client-contact-fields/models";
import autoTable from "jspdf-autotable";
import { WorkSheet } from "xlsx";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { TableModule } from "primeng/table";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TagComponent } from "../main/common/tags/tag.component";

import { NgIf, NgFor } from "@angular/common";
import { DashboardService } from "../dashboard.service";

@Component({
  selector: "app-custom-data-dashboard",
  templateUrl: "./custom-data-dashboard.component.html",
  styleUrls: ["./../p-table-dashboards.scss"],
  imports: [
    NgIf,
    NgFor,
    TagComponent,
    TooltipModule,
    TagAddComponent,
    BsDropdownModule,
    TableModule,
    SharedModule
],
})
export class CustomDataDashboardComponent implements OnInit {
  @ViewChild("workspaceFilterTagList") workspaceFilterTagList: TagAddComponent;
  dashboardFor: number = DataFieldFor.Company;
  data;
  loading: boolean = true;
  totalRecords: number = 0;
  cols = [];
  customData;
  workspace_tags_filter: any[];
  lastLazyEvent: LazyLoadEvent;
  dashboardName = "customDataDashboard";
  dashboardTypeDisplay: string = "Client Data";
  andOrFilter: string = "or";
  initialFilters = {
    [this.dashboardName]: {
      rows: 25,
    },
  };

  constructor(
    private localStorage: LocalStorageService,
    public sharedDataService: SharedDataService,
    private customDataService: CustomDataService,
    public dashboardService: DashboardService,
  ) {}
  ngOnInit(): void {
    if (!this.dashboardService.filters()[this.dashboardName]) {
      this.dashboardService.filters.update((prevState = {}) => ({
        ...prevState,
        ...this.initialFilters,
      }));
    }
    this.data = this.sharedDataService.data;

    this.workspace_tags_filter =
      this.localStorage.get("workspace_tags_filter") || [];
  }

  async getDashboardData(event): Promise<void> {
    this.loading = true;
    this.lastLazyEvent = event;
    const { custom_data, columns, total_count } =
      await this.customDataService.getCustomDataDashboardData(
        this.workspace_tags_filter,
        this.dashboardFor,
        this.lastLazyEvent.first,
        this.lastLazyEvent.rows,
        this.andOrFilter,
      );
    this.customData = custom_data;
    this.cols = columns;
    this.totalRecords = total_count;
    console.log("FIELDS", custom_data);
    this.loading = false;
  }

  removeTagFromFilter(tag): void {
    this.workspaceFilterTagList.tags.push(tag);
    this.workspace_tags_filter = this.workspace_tags_filter.filter((t) => {
      return t.uuid !== tag.uuid;
    });
    this.workspaceFilterTagList.addedTags = this.workspace_tags_filter;

    this.localStorage.set("workspace_tags_filter", this.workspace_tags_filter);
    this.getDashboardData(this.lastLazyEvent);
  }

  addTagToFilter(tag): void {
    this.workspace_tags_filter = [...this.workspace_tags_filter, tag];
    this.workspaceFilterTagList.addedTags = this.workspace_tags_filter;
    this.localStorage.set("workspace_tags_filter", this.workspace_tags_filter);
    this.getDashboardData(this.lastLazyEvent);
  }

  andOrFilterChanged(andOr): void {
    this.andOrFilter = andOr;
    this.getDashboardData(this.lastLazyEvent);
  }

  debugLazyLoad(event): void {
    console.log(event);
  }

  onPageChange(event) {
    this.dashboardService.filters.update((prevState) => ({
      ...prevState,
      [this.dashboardName]: {
        ...prevState[this.dashboardName],
        rows: event.rows,
      },
    }));
  }

  async exportPdf(): Promise<void> {
    this.loading = true;
    let { custom_data, columns } =
      await this.customDataService.getCustomDataDashboardData(
        this.workspace_tags_filter,
        this.dashboardFor,
      );

    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then((x) => {
        const doc = new jsPDF.default("l", "pt");
        autoTable(doc, {
          head: [columns.map((col) => col.header)],
          body: custom_data.map((data) => {
            return columns.map(({ field }) => data[field]);
          }),
        });
        doc.save(
          `custom_data_dashboard${new Date()
            .toDateString()
            .replace(" ", "_")}.pdf`,
        );
      });
    });
    this.loading = false;
  }

  async exportExcel(): Promise<void> {
    this.loading = true;
    let { custom_data, columns } =
      await this.customDataService.getCustomDataDashboardData(
        this.workspace_tags_filter,
        this.dashboardFor,
      );

    import("xlsx").then((xlsx) => {
      let formattedData = custom_data.map((data) => {
        return columns.reduce((obj, col) => {
          obj[col.field] = data[col.field];
          return obj;
        }, {});
      });

      const wb = xlsx.utils.book_new();
      const ws: WorkSheet = xlsx.utils.json_to_sheet([]);
      xlsx.utils.sheet_add_aoa(ws, [columns.map((col) => col.header)]);

      xlsx.utils.sheet_add_json(ws, formattedData, {
        origin: "A2",
        skipHeader: true,
      });

      xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
      xlsx.writeFile(
        wb,
        `custom_data_dashboard${new Date().toDateString()}.xlsx`,
      );

      this.loading = false;
    });
  }

  async exportCsv(): Promise<void> {
    this.loading = true;
    let { custom_data, columns } =
      await this.customDataService.getCustomDataDashboardData(
        this.workspace_tags_filter,
        this.dashboardFor,
      );
    let csvContent = "data:text/csv;charset=utf-8,";
    const exportCols = columns.map((col) => col.header);
    csvContent += exportCols.join(",") + "\n";
    console.log("EXPORT COLS", exportCols);
    console.log("CSV CONTENT WITH COLUMNS", csvContent);
    custom_data.forEach((data) => {
      const rowData = columns.map((col) => data[col.field] ?? "-");
      csvContent += rowData.join(",") + "\n";
    });
    console.log("CSV CONTENT WITH ROW DATA", csvContent);
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute(
      "download",
      `custom_data_dashboard_${new Date().toDateString().replace(" ", "_")}.csv`,
    );
    document.body.appendChild(link);
    link.click();
    this.loading = false;
  }
}
